











import HistorySuggestion from '@empathybroker/ebx-gluon/dist/components/pure/suggestions/history-suggestion.vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlHistorySuggestion extends HistorySuggestion {}
